/* @flow */
import * as React from 'react';
import Button from 'components/Button';
import EventTracking from 'lib/EventTracking';
import { withRouter } from 'app/context/Router';
import ModalTrigger from 'components/ModalTrigger';
import AdminUpgradeHelpModal from 'admin/components/AdminUpgradeHelpModal';

type Props = {
  router: *,
  full?: boolean,
  eventKey?: string,
  quoteUuid?: ?string,
};

class AdminUpgradeHelp extends React.Component<Props> {
  handleDone = () => {
    this.props.router.push('/admin_upgrade/contact_us/done');
  };

  trackModalOpen = () => {
    EventTracking.trackKey(this.props.eventKey || `admin_self_serve.contact_us.click`);
  };

  renderModal = () => {
    return (
      <AdminUpgradeHelpModal
        onDone={this.handleDone}
        quoteUuid={this.props.quoteUuid}
        source="self_serve"
      />
    );
  };

  render() {
    return (
      <ModalTrigger modal={this.renderModal()} onClick={this.trackModalOpen}>
        <Button level="secondary" full={this.props.full}>
          Contact sales
        </Button>
      </ModalTrigger>
    );
  }
}

export { AdminUpgradeHelp };
export default withRouter(AdminUpgradeHelp);
